import React from 'react';
import { Container } from 'reactstrap';
import CrudList from './list';

const GeologiaShapeFileTerrasIndigenas = () => (
  <div className="containerInside__wrap">
    <Container>
      <CrudList />
    </Container>
  </div>
);

export default GeologiaShapeFileTerrasIndigenas;